angular
  .module("app")
  .controller("CampanhaDoarSucessoController", function ($scope, $http) {
    $scope.checking = false;
    $scope.paymentOk = false;

    $scope.checkPayment = function () {
      if ($scope.paymentOk) {
        return true;
      }

      $scope.checking = true;
      $http({
        url: window.location.href.replace("/sucesso", "/status-pagamento"),
      })
        .then(function (res) {
          $scope.checking = false;
          angular.element("#payment-status-info").html(res.data.msg);
          angular
            .element("#payment-status-info")
            .removeClass("text-danger")
            .removeClass("text-success");
          if (res.data.status) {
            angular.element("#payment-status-info").addClass("text-success");
            $scope.paymentOk = true;
          } else {
            angular.element("#payment-status-info").addClass("text-danger");
          }
        })
        .catch(function (err) {
          $scope.checking = false;
        });
    };

    $scope.copiarParaAreaDeTransferencia = function (
      elementId,
      elementSuccessId
    ) {
      var copyText = document.getElementById(elementId);

      copyText.select();
      copyText.setSelectionRange(0, 99999);
      document.execCommand("copy");

      $("#" + elementSuccessId)
        .hide()
        .removeClass("hide")
        .fadeIn("slow", function () {
          setTimeout(function () {
            $("#" + elementSuccessId).fadeOut();
          }, 2000);
        });
    };
  });
